import HttpClient from "../services/HttpClient";
import {
  APP_URL_CONTRACT,
  CONTRACTTYPE,
  CONTRACTTYPEVALUES,
  ERROR_MESSAGE,
  CONTRACTTYPECLAUSES,
  CONTRACTTYPEFORMATCLAUSE,
  CONTRACTTYPEFORMATS,
  CONTRACTTYPEFORMATE,
  CONTRACTBYTYPEFORMAT
} from "../constants";

export const getFilterContractTypes = (filter, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    let filters = "";
    if (filter.status && filter.contractType) {
      filters = `?status=${filter.status}&contractType=${filter.contractType}`;
    } else if (filter.status) {
      filters = `?status=${filter.status}`;
    } else if (filter.contractType) {
      filters = `?contractType=${filter.contractType}`;
    }

    HttpClient.get(`${APP_URL_CONTRACT}${CONTRACTTYPE}${filters}`, headers)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
      });
  });
};

export const getContractTypesValues = (dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = { "Content-Type": "application/json" };
    HttpClient.get(`${APP_URL_CONTRACT}${CONTRACTTYPEVALUES}`, headers)
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
      });
  });
};

export const getContractTypeById = (id, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(`${APP_URL_CONTRACT}${CONTRACTTYPE}/${id}`, headers)
      .then((response) => {
        if (response.data) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
      });
  });
};

export const saveContractType = (contractType, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(`${APP_URL_CONTRACT}${CONTRACTTYPE}`, contractType, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: error?.data ? error?.data?.detail : ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

export const editContractType = (contractType, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.put(`${APP_URL_CONTRACT}${CONTRACTTYPE}`, contractType, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: error?.data ? error?.data?.detail : ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

export const updateContractType = (requisition, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.put(`${APP_URL_CONTRACT}${CONTRACTTYPE}`, requisition, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

export const updateContractTypeClausesFormat = (
  listClauses,
  dispatch,
  //isUpdate,
  //updateId
) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    //let method = isUpdate ? "put" : "post";
    let method =  "put";
    HttpClient[method](
      `${APP_URL_CONTRACT}${CONTRACTTYPEFORMATCLAUSE}`,
      listClauses,
      headers
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

export const getClausesByContractTypeFormat = (id, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(
      `${APP_URL_CONTRACT}${CONTRACTTYPEFORMATCLAUSE}?contractTypeFormatId=${id}`,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
      });
  });
};

export const getContractTypeFormatByContractType = (id, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.get(
      `${APP_URL_CONTRACT}${CONTRACTTYPEFORMATS}${id}`,
      headers
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: ERROR_MESSAGE,
          },
        });
        reject(error.response);
      });
  });
};

export const saveContractTypeFormat = (contractTypeFormat, dispatch) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(`${APP_URL_CONTRACT}${CONTRACTBYTYPEFORMAT}`, contractTypeFormat, headers)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        dispatch({
          type: "OPEN_SNACKBAR",
          openMessage: {
            open: true,
            message: error?.data ? error?.data?.detail : ERROR_MESSAGE,
          },
        });
        resolve(error.response);
      });
  });
};

export const updateContractTypeFormat = (body) => {
  const headers = {'Content-Type': 'application/json'}
  return new Promise((resolve) => {
    HttpClient.put(`${APP_URL_CONTRACT}${CONTRACTBYTYPEFORMAT}`, body, headers).then((response) => {
      resolve(response);
    }).catch((error) => {
      resolve(error.response);
    })
  })
}
